import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import FormService from '../../../core/services/FormService';

class WhitelabelConfigCustomOptionsService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      whitelabelConfigId: null,
    });
    this.form.validations = {
      timeToAllowContinueUnit: [isRequired],
      simpleSpeechRecognition: [isRequired],
      disableEmailSending: [isRequired],
      disableStudentSupport: [isRequired],
      disableStudyQuality: [isRequired],
      disableFlexgeCourse: [isRequired],
      enableAllCourseContent: [isRequired],
    };
  }

  init = action((whitelabelConfigId) => {
    this.whitelabelConfigId = whitelabelConfigId;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/whitelabel-configs/${this.whitelabelConfigId}`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.form.setInitialValues(this.fetch.data.configuration);
        } else {
          this.form.setInitialValues({
            timeToAllowContinueUnit: 15,
            simpleSpeechRecognition: false,
            disableEmailSending: false,
            disableStudentSupport: false,
            disableStudyQuality: false,
            disableFlexgeCourse: false,
            enableAllCourseContent: false,
          });
        }
      });
  });

  handleSubmit = action(() => {
    this.submit
      .fetch({
        url: `/whitelabel-configs/${this.whitelabelConfigId}/configurations`,
        method: 'patch',
        body: this.form.getValues(),
      })
      .then(() => {
        if (this.submit.data) {
          this.load();
          NotificationService.addNotification('Custom options updated', 'success');
        } else {
          NotificationService.addNotification('Error to update custom options', 'error');
        }
      });
  });
}

export default WhitelabelConfigCustomOptionsService;
